/* The extension's copy, corrected.

   THE SUBTITLE WAS MISSING THE MARQUE. "Your VIN matches our production records
   for a 2025 Super Sport." A model name on its own is not an identification:
   Super Sport is a Futura and 1883 is a SHIFTR, and the customer has just
   handed over a VIN precisely so the store can tell them which trailer they
   own. The line reads "... for a 2025 Futura Super Sport trailer."

   THE HERO TITLE HAD IT TWICE. "Your 2026 SHIFTR Shiftr 1883 trailer." The
   heading is built as brand plus model, and the model name in the lookup
   service is "Shiftr 1883" rather than "1883", so the marque is printed, then
   printed again in lower case. THIS IS A DATA FAULT AND THIS IS NOT THE FIX.
   The model should be renamed to 1883 wherever the VIN service keeps its
   models; until then this stops the customer seeing it. It only ever removes a
   repeat of the brand that is already there, so once the data is corrected this
   finds nothing and does nothing.

   THE FITMENT BADGES SAID TRAILER TOO OFTEN. Every card in a grid that exists
   only because a trailer was identified carried "Fits trailer", which is the
   one word in the badge that adds nothing: what else would it fit. "Fits" and
   "Likely fits" say the same thing and leave the eye on the difference between
   them, which is the part that matters.

   IT IS A SEPARATE FILE FOR A REASON. This is the extension's copy, not its
   layout, and assets/fx-ext-modal.js is already at 8KB against a theme file
   write that starts truncating around 12. One file, one job.

   THE SUBTITLE'S BRAND COMES OFF THE HERO TITLE, NOT THE BRAND SWITCH. The
   switch is a browsing control: a Futura owner can flip it to SHIFTR to look at
   the other marque's catalogue, and their trailer does not change marque when
   they do. The hero title carries the brand the VIN resolved to.

   IT IS IDEMPOTENT AND IT HAS TO BE. A MutationObserver watches the body, and
   rewriting text inside the body is itself a mutation. Every rewrite is
   compared against what is already there and skipped when they match, so the
   second pass is a no-op and the loop closes instead of running forever.

   setTimeout, not requestAnimationFrame: rAF does not fire in a tab that is
   not being painted, and a queued flag that is never cleared drops every
   mutation after it. */
(function () {
  var queued = null;

  function heroEl() {
    return document.querySelector('.vin-fx-hero-title');
  }

  function brandNow() {
    var hero = heroEl();
    var t = hero ? hero.textContent : '';
    if (/shiftr/i.test(t)) return 'SHIFTR';
    if (/futura/i.test(t)) return 'Futura';

    var sw = document.querySelector('.vin-fx-brand-switch');
    var v = sw && sw.getAttribute('data-fx-brand');
    return String(v).toLowerCase() === 'shiftr' ? 'SHIFTR' : 'Futura';
  }

  /* "2026 SHIFTR Shiftr 1883" becomes "2026 SHIFTR 1883". The match is on the
     brand repeated as the very next word, in any case, so a model that merely
     contains the word elsewhere is left alone. */
  function fixHero() {
    var hero = heroEl();
    if (!hero) return;
    var text = hero.textContent.replace(/\s+/g, ' ');
    var next = text.replace(/\b(futura|shiftr)\s+\1\b/gi, '$1');
    if (next !== text) hero.textContent = next;
  }

  /* "... for a 2025 Super Sport." splits into the lead, an optional year, and
     the model. The brand is dropped from the model first so a line that has
     already been through here is rebuilt to exactly itself rather than
     collecting a second "Futura" on every pass. Same for the trailing noun. */
  function fixSubtitle() {
    var ps = document.querySelectorAll('.vin-modal-header p');

    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      var text = p.textContent.replace(/\s+/g, ' ').trim();
      if (!/production records/i.test(text)) continue;

      var m = text.match(/^(.*\bfor an?\s+)((?:19|20)\d{2}\s+)?(.+?)\.?$/i);
      if (!m) continue;

      var model = m[3]
        .replace(/^(?:futura|shiftr)\s+/i, '')
        .replace(/\s+trailers?$/i, '')
        .trim();
      if (!model) continue;

      var next = m[1] + (m[2] || '') + brandNow() + ' ' + model + ' trailer.';
      if (next !== text) p.textContent = next;
    }
  }

  /* Keyed on what the badge says rather than on which modifier class it
     carries, so a third fitment state added later is left alone rather than
     silently relabelled as one of these two. */
  var FIT = {
    'fits trailer': 'Fits',
    'likely fits trailer': 'Likely fits'
  };

  function fixFit() {
    var tags = document.querySelectorAll('.vin-fx-fit-tag__label');
    for (var i = 0; i < tags.length; i++) {
      var now = tags[i].textContent.replace(/\s+/g, ' ').trim();
      var want = FIT[now.toLowerCase()];
      if (want && now !== want) tags[i].textContent = want;
    }
  }

  function pass() {
    queued = null;
    try { fixHero(); } catch (e) { /* hero not built yet */ }
    try { fixSubtitle(); } catch (e) { /* header not built yet */ }
    try { fixFit(); } catch (e) { /* no results grid on screen */ }
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
